import React, { useEffect, useRef, useState } from 'react';

const VoiceWaveBars = () => {
  const canvasRef = useRef(null);
  const [isListening, setIsListening] = useState(false);

  useEffect(() => {
    let audioContext, analyser, microphone, dataArray, animationFrameId;

    const startListening = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });

        audioContext = new (window.AudioContext ||
          window.webkitAudioContext)();
        analyser = audioContext.createAnalyser();
        microphone = audioContext.createMediaStreamSource(stream);
        microphone.connect(analyser);

        analyser.fftSize = 64; // Small FFT for smoother bars
        const bufferLength = analyser.frequencyBinCount;
        dataArray = new Uint8Array(bufferLength);

        setIsListening(true);

        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');

        const drawBars = () => {
          analyser.getByteFrequencyData(dataArray);
          ctx.clearRect(0, 0, canvas.width, canvas.height);

          const barWidth = canvas.width / bufferLength;
          const centerY = canvas.height / 2;
          const barHeightMultiplier = centerY / 128;

          // Calculate loudness (average of frequency data)
          const avgVolume =
            dataArray.reduce((a, b) => a + b, 0) / bufferLength;

          if (avgVolume < 10) {
            // If no sound detected, draw a single center line
            ctx.fillStyle = '#888';
            ctx.fillRect(0, centerY - 1, canvas.width, 2);
          } else {
            // If sound detected, draw the wave bars
            for (let i = 0; i < bufferLength; i++) {
              const barHeight = dataArray[i] * barHeightMultiplier;
              ctx.fillStyle = '#888'; // Gray bars like the image
              const x = i * barWidth;

              // Draw top bar
              ctx.fillRect(
                x,
                centerY - barHeight,
                barWidth * 0.8,
                barHeight,
              );

              // Draw bottom bar (mirrored)
              ctx.fillRect(x, centerY, barWidth * 0.8, barHeight);
            }
          }

          animationFrameId = requestAnimationFrame(drawBars);
        };

        drawBars();
      } catch (error) {
        console.error('Error accessing microphone:', error);
      }
    };

    startListening();

    return () => {
      if (audioContext) {
        audioContext.close();
      }
      cancelAnimationFrame(animationFrameId);
      setIsListening(false);
    };
  }, []);

  return (
    <div className='flex flex-col items-center gap-2'>
      <svg
        width="32"
        height="34"
        viewBox="0 0 32 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.76953 10.5875C6.76953 5.48879 10.9029 1.35547 16.0016 1.35547C21.1003 1.35547 25.2336 5.48879 25.2336 10.5875V18.2809C25.2336 23.3796 21.1003 27.5129 16.0016 27.5129C10.9029 27.5129 6.76953 23.3796 6.76953 18.2809V10.5875Z"
          stroke="#1C274C"
          stroke-width="2.5"
        />
        <path
          opacity="0.5"
          d="M12.9219 8.28105C12.9219 8.28105 13.6492 7.51172 15.9992 7.51172C18.3492 7.51172 19.0766 8.28105 19.0766 8.28105"
          stroke="#1C274C"
          stroke-width="2.5"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M12.9219 12.8943C12.9219 12.8943 13.6492 12.125 15.9992 12.125C18.3492 12.125 19.0766 12.8943 19.0766 12.8943"
          stroke="#1C274C"
          stroke-width="2.5"
          stroke-linecap="round"
        />
        <path
          opacity="0.5"
          d="M29.8484 15.2031V18.2805C29.8484 25.9286 23.6485 32.1285 16.0004 32.1285C8.35233 32.1285 2.15234 25.9286 2.15234 18.2805V15.2031"
          stroke="#1C274C"
          stroke-width="2.5"
          stroke-linecap="round"
        />
      </svg>
      <div className="flex items-center justify-center">
        <canvas
          ref={canvasRef}
          width={150}
          height={20}
          style={{ background: 'transparent' }}
        />
        <p
          style={{
            color: isListening ? '#0f0' : '#f00',
            fontWeight: 'bold',
          }}
        >
          {/* {isListening ? "🎙️ Listening..." : "🔇 Mic Off"} */}
        </p>
      </div>
    </div>
  );
};

export default VoiceWaveBars;
